module.exports = __webpack_public_path__ + "img/transfer30.59603ff7.jpeg";